/* ==========================================================================
   Sticky Scroll Features
   --------------------------------------------------------------------------
   IntersectionObserver watches each text block. When a block's center
   enters the viewport's middle band, that block's matching image gets
   `.is-active`, the others lose it. CSS handles the crossfade.
   ========================================================================== */
(function () {
    document.querySelectorAll('.sticky-features').forEach(initSection);

    function initSection(section) {
        const items  = section.querySelectorAll('[data-feature-index]');
        const images = section.querySelectorAll('[data-image-index]');
        if (items.length === 0 || images.length === 0) return;

        function setActive(index) {
            images.forEach(img => {
                img.classList.toggle(
                    'is-active',
                    img.dataset.imageIndex === String(index)
                );
            });
        }

        /* Trigger when a text block's center hits the middle of the viewport.
           rootMargin with negative top/bottom creates a thin "focus band"
           in the middle; whichever block is inside that band is active. */
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const index = entry.target.dataset.featureIndex;
                        setActive(parseInt(index, 10));
                    }
                });
            },
            {
                root: null,
                /* -40% top and -40% bottom leaves a 20% band in the middle
                   of the viewport. Adjust if the swap feels too eager or
                   too sluggish. */
                rootMargin: '-40% 0px -40% 0px',
                threshold: 0
            }
        );

        items.forEach(item => observer.observe(item));
    }
})();
